module.exports = __webpack_public_path__ + "static/img/swedavia.fc76cd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/about/assets/swedavia.jpg
// module id = Ej2/
// module chunks = 0